import { render } from "./LocationConfirmDialog.vue?vue&type=template&id=672d7f4e&scoped=true"
import script from "./LocationConfirmDialog.vue?vue&type=script&lang=js"
export * from "./LocationConfirmDialog.vue?vue&type=script&lang=js"

import "./LocationConfirmDialog.vue?vue&type=style&index=0&id=672d7f4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672d7f4e"]])

export default __exports__